export enum TeammateStatus {
    ok = 'OK',
    invited = 'INVITED',
    changePassword = 'CHANGEPASSWORD',
    validateEmail = 'VALIDATE_EMAIL',
    block = 'BLOCK'
}
